import React, { useState, useMemo } from 'react'
import { Checkbox, FormControlLabel, Grid } from '@the-platform-group/component-library'
import { usePeopleMergeContext } from 'pages/MergeProfiles/contexts/PeopleMergeContext'
import JobLabel from './JobLabel'
import { findJobsBySearchTerm } from './utils'
import JobsListWrapper, { NoJobsAvailable, NoJobsMatchSearch } from './JobsListWrapper'

/**
 * PlatformJobsList - Displays selectable list of Platform jobs (source profile jobs) for mapping
 * Shows all unmapped Platform jobs from the source profile with checkboxes for selection.
 * These are jobs that need to be mapped to FactSet jobs in the target profile.
 * @returns {React.Component} List of selectable Platform jobs with search
 */
const PlatformJobsList = () => {
  const { mergeData, jobMappingData } = usePeopleMergeContext()
  const { sourceJobs } = mergeData.selectedData
  const { previewJobsMap } = mergeData.mergePreviewMeta
  const { selectedPlatformJobs, toggleJobSelection, mappedSourceJobIds } = jobMappingData

  const [searchTerm, setSearchTerm] = useState('')

  const unmappedJobs = useMemo(() => {
    return sourceJobs.filter(job => !mappedSourceJobIds.includes(job.id))
  }, [sourceJobs, mappedSourceJobIds])

  const filteredJobs = useMemo(
    () => findJobsBySearchTerm(unmappedJobs, searchTerm),
    [unmappedJobs, searchTerm],
  )

  const handleCheckboxChange = jobId => {
    toggleJobSelection(jobId)
  }

  return (
    <JobsListWrapper title="Platform Jobs" searchTerm={searchTerm} setSearchTerm={setSearchTerm}>
      <Grid item container sx={{ flexGrow: 1, overflowY: 'auto' }}>
        {!unmappedJobs.length && <NoJobsAvailable />}
        {!unmappedJobs.length && Boolean(filteredJobs.length) && <NoJobsMatchSearch />}
        {Boolean(unmappedJobs.length) &&
          Boolean(filteredJobs.length) &&
          filteredJobs.map(job => (
            <Grid
              item
              xs={12}
              key={job.id}
              sx={{
                py: 0.5,
                borderBottom: '1px solid',
                borderColor: 'divider',
                '&:last-child': { borderBottom: 'none' },
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedPlatformJobs.includes(job.id)}
                    onChange={() => handleCheckboxChange(job.id)}
                  />
                }
                label={<JobLabel job={job} jobPreview={previewJobsMap.get(job.id)} />}
              />
            </Grid>
          ))}
      </Grid>
    </JobsListWrapper>
  )
}

export default PlatformJobsList
